import {bulkUsers} from 'src/utils/constants/bulk-users'
import Md5 from 'md5'

export const confirmBulkUser = (userId) => {
  return bulkUsers.includes(Md5(userId.toLowerCase()))
}
